import { ORGANIZATION_ROLE } from 'site-constants';

import { CANDU_PLANS, ROLES } from './constants';

const ENTERPRISE_ONLY_ROLES = [ORGANIZATION_ROLE.Editor];
const ENTERPRISE_PLANS = [CANDU_PLANS.CANDU, CANDU_PLANS.ENTERPRISE];

const applyRoleRestrictionsForOrganizationPlan = (roles, organizationPlanId) => {
  if (!ENTERPRISE_PLANS.includes(organizationPlanId)) {
    return roles.filter((role) => !ENTERPRISE_ONLY_ROLES.includes(role.value));
  }
  return roles;
};

const permissions = {
  Superuser: ['Superuser', 'Owner', 'Admin', 'Publisher', 'Editor', 'ReadOnly'],
  Owner: ['Owner', 'Admin', 'Publisher', 'Editor', 'ReadOnly'],
  Admin: ['Admin', 'Editor', 'Publisher', 'ReadOnly'],
  Publisher: ['Publisher', 'Editor', 'ReadOnly'],
  Editor: ['Editor', 'ReadOnly'],
  ReadOnly: ['ReadOnly'],
};

const availableRoles = {
  Superuser: [
    { label: ROLES.Owner, value: 'Owner' },
    { label: ROLES.Admin, value: 'Admin' },
    { label: ROLES.Publisher, value: 'Publisher' },
    { label: ROLES.Editor, value: 'Editor' },
    { label: ROLES.ReadOnly, value: 'ReadOnly' },
  ],
  Owner: [
    { label: ROLES.Owner, value: 'Owner' },
    { label: ROLES.Admin, value: 'Admin' },
    { label: ROLES.Publisher, value: 'Publisher' },
    { label: ROLES.Editor, value: 'Editor' },
    { label: ROLES.ReadOnly, value: 'ReadOnly' },
  ],
  Admin: [
    { label: ROLES.Admin, value: 'Admin' },
    { label: ROLES.Publisher, value: 'Publisher' },
    { label: ROLES.Editor, value: 'Editor' },
    { label: ROLES.ReadOnly, value: 'ReadOnly' },
  ],
  Publisher: [],
  Editor: [],
  ReadOnly: [],
};

const availableInviteRoles = {
  ...availableRoles,
  Owner: [
    { label: ROLES.Admin, value: 'Admin' },
    { label: ROLES.Publisher, value: 'Publisher' },
    { label: ROLES.Editor, value: 'Editor' },
    { label: ROLES.ReadOnly, value: 'ReadOnly' },
  ],
  Publisher: [
    { label: ROLES.Publisher, value: 'Publisher' },
    { label: ROLES.Editor, value: 'Editor' },
    { label: ROLES.ReadOnly, value: 'ReadOnly' },
  ],
  Editor: [
    { label: ROLES.Editor, value: 'Editor' },
    { label: ROLES.ReadOnly, value: 'ReadOnly' },
  ],
};

export const hasPermissionToDelete = (currentUserRole, userPermission) => {
  return availableRoles[currentUserRole].map((role) => role.value).includes(userPermission);
};

export const hasPermissionToChange = (currentUserRole, userPermission, organizationPlanId) => {
  // temporary fix for AppSumo users who created Editor roles
  if (userPermission === ORGANIZATION_ROLE.Editor) {
    return permissions[currentUserRole].includes(userPermission);
  }
  return applyRoleRestrictionsForOrganizationPlan(
    permissions[currentUserRole],
    organizationPlanId,
  ).includes(userPermission);
};

export const getPermissions = (currentUserRole, organizationPlanId) => {
  return applyRoleRestrictionsForOrganizationPlan(
    availableRoles[currentUserRole],
    organizationPlanId,
  );
};

export const getInvitePermissions = (currentUserRole, organizationPlanId) => {
  return applyRoleRestrictionsForOrganizationPlan(
    availableInviteRoles[currentUserRole],
    organizationPlanId,
  );
};

export const hasExperimentation = (userState) => {
  return userState?.organizationPlanId !== CANDU_PLANS.APPSUMO;
};
